// Third-party Imports
import { z } from 'zod'

const email = z.string().trim().min(1, 'Enter your email address.').email('Enter a valid email address.')

/** Sign-IN only: the floor is "did you type something". Length rules on an existing password would
 *  reject a legitimate account created before the rule existed. */
const currentPassword = z.string().min(1, 'Enter your password.')

/** Sign-UP and reset: this password is being created now, so the floor applies. */
const newPassword = z.string().min(8, 'Use at least 8 characters.')

const fullName = z.string().trim().min(1, 'Enter your name.').max(60, 'Keep your name under 60 characters.')

/**
 * АЖИЛТНЫ КОД — ЯГ 8 ОРОНТОЙ ЦИФР.
 *
 * ! Дүрэм нь эх системийнхтэй ҮСЭГ ҮСГЭЭРЭЭ ижил
 * ! (`EmployeeAuthService::CODE_PATTERN = '/^\d{8}$/'`). Хоёр талын
 * ! таних дүрэм зөрвөл хэрэглэгч нэг систем дээр кодоороо ороод нөгөө
 * ! дээр нь орж чадахгүй болно.
 *
 * ! И-мэйлтэй ДАВХЦАХ БОЛОМЖГҮЙ: и-мэйл заавал `@` агуулна, код зөвхөн цифр.
 */
export const looksLikeEmployeeCode = (value: string): boolean => /^\d{8}$/.test(value.trim())

/**
 * НЭГДСЭН НЭВТРЭЛТ — нэг талбар.
 *
 * ! Урьд нь и-мэйл ЗААВАЛ байсан (`@IsEmail`) тул ажилтны кодоор нэвтрэх
 * ! гэсэн хүн «И-мэйл хаяг буруу байна» гэсэн хариу авдаг байв — өөрөөр
 * ! хэлбэл кодоор нэвтрэх зам панел дээр ОГТ байхгүй байсан.
 *
 * ! Урт шалгахгүй: PIN нь 8 цифр, нууц үг нь урт — хоёуланд нь тохирох
 * ! доод хязгаар гэж байхгүй. «Юм бичсэн үү» гэдэг л энд хамаатай
 * ! (сервер тал бодит шалгалтаа хийнэ).
 */
export const signInSchema = z.object({
  identifier: z
    .string()
    .trim()
    .min(1, 'Нэвтрэх нэрээ оруулна уу.')
    .refine(value => value.includes('@') || looksLikeEmployeeCode(value), {
      message: 'И-мэйл хаяг эсвэл 8 оронтой ажилтны код оруулна уу.'
    }),
  password: currentPassword,
  rememberMe: z.boolean()
})

export const signUpSchema = z.object({
  name: fullName,
  email,
  password: newPassword
})

export const forgotPasswordSchema = z.object({ email })

export const resetPasswordSchema = z
  .object({
    password: newPassword,
    confirmPassword: z.string().min(1, 'Re-enter your new password.')
  })
  .refine(values => values.password === values.confirmPassword, {
    message: 'Both passwords must match.',
    path: ['confirmPassword']
  })

export const acceptInvitationSchema = z.object({
  name: fullName,
  password: newPassword
})

export type SignInValues = z.infer<typeof signInSchema>
export type SignUpValues = z.infer<typeof signUpSchema>
export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>
export type AcceptInvitationValues = z.infer<typeof acceptInvitationSchema>
